import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Dashboardv2Component } from './dashboardv2.component';
import { RouterModule, Routes } from '@angular/router';
import { Dashboardv2ISOComponent } from './dashboardv2-iso.component';
import { Dashboardv2SystemComponent } from './dashboardv2-system.component';
import { Dashboardv2MerchantComponent } from './dashboardv2-merchant.component';
import { CustomersTpnListv2Component } from './customers-tpn-listv2/customers-tpn-listv2.component';
import { DeactivatedMerchantListv2Component } from './deactivated-merchant-listv2/deactivated-merchant-listv2.component';
import { LessSalesMerchantsv2Component } from './less-sales-merchantsv2/less-sales-merchantsv2.component';
import { NotTransactTpnlistv2Component } from './not-transact-tpnlistv2/not-transact-tpnlistv2.component';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
// import { SharedModule } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { datePipeModule } from 'src/app/shared/pipe/datePipe.module';
import { ZingchartAngularModule } from 'zingchart-angular';
import "zingchart/modules-es6/zingchart-maps.min.js";
import "zingchart/modules-es6/zingchart-maps-usa.min.js";
import zingchart from 'zingchart/es6';
import { SharedModule } from '../../../shared/shared.module';


const routes: Routes = [
  {
    path: '',
    component: Dashboardv2Component
  }
]


@NgModule({
  declarations: [Dashboardv2Component, Dashboardv2ISOComponent, Dashboardv2SystemComponent, Dashboardv2MerchantComponent, CustomersTpnListv2Component, DeactivatedMerchantListv2Component, LessSalesMerchantsv2Component, NotTransactTpnlistv2Component],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbDropdownModule,
    FeahterIconModule,
    NgApexchartsModule,
    TranslateModule,
    NgxUiLoaderModule,
    NgSelectModule,
    FormsModule,
    CheckboxModule,
    SharedModule,
    datePipeModule.forRoot(),
    ZingchartAngularModule,
  ]
})
export class Dashboardv2Module { }
